module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/microsoft-badge-nocolor-3a4c13bfd84950607feb597cfe2aea24.svg";